import type { FaireProductEntity } from "../../entity_types/product";

export const p_xustvkwdcc: FaireProductEntity = {
  token: "p_xustvkwdcc",
  type: "product",
  name: "A-Z Mindful Affirmation Cards",
  brandToken: "b_pt47qddvxc",
  brandName: "Mindful and Co Kids USA",
  imageUrl: "https://cdn.faire.com/fastly/5d251466cd660506c7349fbcc977a4d4bc14f6e50da63a14083f6cd015290659.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0dc5f97031215bef58d5a7b54aa1fab623a696ab27f5a0be9dfe22833315fcd7.png",
    "https://cdn.faire.com/fastly/1839356eac5a6469b033d1fe4c0c41f73086ef77fcd96be7190b2516a26f3c48.png",
    "https://cdn.faire.com/fastly/7f10855854e6de3ef9f42e30175e30652ec3d6bcd4ad3ebbc8b74ffcba54e1e6.jpeg",
    "https://cdn.faire.com/fastly/847ef90f40013a3dddca7ea0e9ed894afecdcb65ac75a50e9b625ed15b20c026.jpeg",
    "https://cdn.faire.com/fastly/9a3bca49d3297e4bb92e7f952d3af2152f8a3f748e4c0bc166da1142e6f1d6d5.jpeg"
  ],
  priceDollars: 17.5,
  description: "Ignite Your Child's Inner Spark with A-Z Affirmation Cards - The Ultimate Back-to-School Toy!\n\nEmpower your child with positivity, confidence, and joy using Mindful & Co Kids' enchanting A-Z Affirmation Cards. These captivating cards harness the power of positive thinking, fostering communication skills, connections, and calm thoughts.\n\nBenefits:\n\nEncourages positive thinking.\nImproves communication skills.\nFosters connections and friendships.\nEncourages calm thoughts and actions.\nIncreases mindfulness.\nSuitable for home, classroom, and daycare use, these sustainable cards are perfect for ages 18m+ to 100 years old. Give your child the gift of a positive mindset that will stay with them throughout life.\n\nIgnite their inner spark with A-Z Affirmation Cards - a transformative back-to-school essential! ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:52.533Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
